module.exports = __webpack_public_path__ + "static/img/contact.2e5f8f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/contact.png
// module id = fwZS
// module chunks = 4